import React, { Fragment } from "react";
import { Menu } from "@headlessui/react";
import { LuCircleUserRound } from "react-icons/lu";

import { RiMenuUnfold3Line } from "react-icons/ri";
import { useSelector } from "react-redux";

export default function Header({ navbarOpen, setNavbarOpen, HeaderJSON, headerName }) {
  function customHeader() {
    switch (headerName) {
      case '/app/dashboard':
        return 'Dashboard';
      case '/app/customer':
        return 'Customer Management';
      case '/app/admin':
        return 'Admin Management';
      case '/app/message':
        return 'Message Management'
      case '/app/notification':
        return 'Notification Management';
      default:
        return 'Default Header';
    }
  }

  // let logedinUser = window.sessionStorage.getItem("adminuser");
  // logedinUser = JSON.parse(logedinUser);
  const adminData = useSelector(state => state.users?.adminData);

  return (
    <Fragment>
      <div className="bgcolor relative z-10 flex-shrink-0 flex h-16 shadow"
        style={{ boxShadow: "rgba(139, 137, 137, 0.25)" }}
      >
        <div className="flex-1 px-4 flex justify-between items-center">
          {/* Left Section: Menu Icon */}
          <div className="flex items-center gap-4">
          <RiMenuUnfold3Line onClick={() => setNavbarOpen(!navbarOpen)} size={24} className="flex-shrink-0 lg:hidden block" />
          
            <h1 className="text-lg font-semibold">{customHeader()}</h1>
           
          </div>

          <div className="flex items-center space-x-6">

            {/* <div className="relative cursor-pointer">
              <FaBell className="text-xl text-gray-500" />
              <span className="absolute top-0 right-0 inline-flex items-center justify-center h-4 w-4 rounded-full bg-red-600 text-white text-xs">
                6
              </span>
            </div> */}

            <div className="flex items-center space-x-2 ">
              <Menu as="div" className="relative inline-block text-left">
                {({ open }) => (
                  <>
                    <Menu.Button className="max-w-xs flex items-center text-sm rounded-full focus:outline-none">
                      <LuCircleUserRound className="rounded-full w-8 h-8 text-gray-800" />
                      {/* <img src={`/${HeaderJSON["Admin-image"]}`} alt="User avatar" className="rounded-full w-10 h-10" /> */}
                    </Menu.Button>
                  </>
                )}
              </Menu>
              <div className="">
                <span className="block text-base font-medium">{ adminData?.name || "Admin"}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
